import Header from '../components/Header';

const $header = document.querySelector('.js-header');

if ($header) {
  const header = new Header($header);
  header.mount();
}
